export const filterMapperByKey = (array: unknown[], key: string) =>
    array.map((item) => ({[key]: item}));
